import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';

export const NewPricingSection = ({ onOpenPopup, pricingData }) => {
  return (
    <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto pt-6">
      {pricingData.map((plan) => (
        <div
          key={plan.id}
          className={`relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col w-full md:w-[calc(50%-0.75rem)] lg:w-[calc(25%-1.125rem)] max-w-sm ${
            plan.popular ? 'border-4 border-yellow-400' : 'border-2 border-gray-200'
          }`}
        >
          {plan.popular && (
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
              <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-xs font-bold px-4 py-1 rounded-full shadow-lg whitespace-nowrap">
                MOST POPULAR
              </div>
            </div>
          )}
          
          <div className="p-6 flex-1 flex flex-col">
            {/* Package Name */}
            <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">{plan.name}</h3>
            
            {/* Price */}
            <div className="text-center mb-3">
              <div className="text-4xl font-black text-orange-600 mb-1">{plan.price}</div>
              <div className="text-sm text-gray-600 font-semibold">{plan.description}</div>
            </div>
            
            {/* Subtitle */}
            <p className="text-sm text-gray-700 text-center mb-4 min-h-[40px]">{plan.subtitle}</p>
            
            {/* Divider */}
            <div className="border-t border-gray-200 mb-4"></div>
            
            {/* Features */}
            <div className="flex-1 mb-4">
              <ul className="space-y-2">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <Check className="text-green-600 flex-shrink-0 mt-0.5" size={18} />
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* CTA Button */}
            <Button
              onClick={onOpenPopup}
              className={`w-full h-11 text-sm font-bold transition-all duration-300 ${
                plan.popular
                  ? 'bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-700 hover:to-orange-600 text-white shadow-lg hover:shadow-xl transform hover:scale-105'
                  : 'bg-gray-900 hover:bg-gray-800 text-white'
              }`}
            >
              Get Started
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
